import { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import SweetAlert from 'react-bootstrap-sweetalert'
import DataTable from 'react-data-table-component'
import { FaSearch } from 'react-icons/fa'
import { AsyncPaginate } from 'react-select-async-paginate'
import KapalService from '../../../../services/kapal/KapalService'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'
import UserService from '../../../../services/user/UserService'
import { cekBerlakuSertifikatByUpt } from '../../../../utilities/Utils'
import ModalInspeksiChecklistHasil from './ModalInspeksiChecklistHasil'

const ModalRekom = ({ showRekom, handleCloseRekom, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const columnsEvaluasi = [
        {
            name: 'Nama',
            cell: row => ((localStorage.getItem("role") === '6' || localStorage.getItem("role") === '1' || localStorage.getItem('isMandatoryPrimer') === 'Y') ? row['nmEvaluator'] : "***")
        },
        {
            name: 'Jenis Komoditi',
            cell: row => <ViewKomoditi idInspeksiEvaluasi={row['idInspeksiEvaluasi']} nomorAjuKapal={row['nomorAjuKapal']} />
        },
        {
            name: 'Catatan Tim Teknis',
            cell: row => row['catatanEvaluator']
        },
        {
            name: 'Usulan Grade',
            cell: row => row['gradeUsul']
        },
        {
            name: 'Tanggal Evaluasi',
            cell: row => row['tglEvaluasi']
        }
    ]
    const [listEvaluasi, setListEvaluasi] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isUnder5GT, setIsUnder5GT] = useState(null)
    const [idInspeksi, setIdInspeksi] = useState(null)
    // const [dataRekomendasi, setDataRekomendasi] = useState(null)

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resDataInspeksi) {
                    setIdInspeksi(resDataInspeksi.data.idInspeksi)
                    const resEvaluasi = await kapalService.listEvaluasiTeknisByIdInspeksi(resDataInspeksi.data.idInspeksi)
                    setListEvaluasi(resEvaluasi.data.data)

                    setIsUnder5GT(dataPpmKapal.ukuranKapal <= 5 ? 'Y' : 'T')

                    const resRekom = await kapalService.listRekomTeknis(resDataInspeksi.data.idInspeksi)
                    // console.log(resRekom)

                    if (resRekom.data.data.length > 0) {
                        const dataRekom = resRekom.data.data[0]
                        const optKesimpulan = await kapalService.getKesimpulanById(dataRekom.idKesimpulan)
                        setValueRekomOpt(optKesimpulan.data)

                        const optionsGrade = [{ value: 'A', label: 'A' }, { value: 'B', label: 'B' }, { value: 'C', label: 'C' }, { value: 'D', label: 'D' }, { value: 'Non Grade', label: 'Non Grade' }]
                        setValueGradeRekomOpt(optionsGrade.find(option => option.value === dataRekom.gradeRekom))

                        const resPegawai = await userService.getPegawaiById(dataRekom.nipRekom)
                        let optPegawai = { nipPenandatangan: resPegawai.data.nip, namaPenandatangan: resPegawai.data.nama }
                        setValuePegawaiOpt(optPegawai)

                        setValueCatatan(dataRekom.catatanRekom)
                        setValueTglRekom(dataRekom.tglRekom)

                        const resRekomProduk = await kapalService.listRekomTeknisProduk(dataRekom.idInspeksiRekom, dataPpmKapal.nomorAjuKapal)
                        const resJenisKomoditi = await kapalService.listJenisKomoditi(null, 0, 20)
                        const optionsJenis = resJenisKomoditi.data.data

                        const mappedSelected = resRekomProduk.data.data.map(item => {
                            const found = optionsJenis.find(
                                opt => (opt.idJenisKomoditi === item.idJenisKomoditi || opt.idJenisKomoditi === item.idKomoditi)
                            );

                            if (!found) return null; // handle jika tidak ketemu

                            return {
                                idJenisKomoditi: found.idJenisKomoditi,
                                urJenisKomoditi: found.urJenisKomoditi,
                                urJenisKomoditiEn: found.urJenisKomoditiEn
                            }
                        }).filter(Boolean)
                        setValueJenisKomoditiOpt(mappedSelected)

                        // const resJenisKomoditi = await kapalService.getJenisKomoditiById(dataRekom.idJenisKomoditi)
                        // setValueJenisKomoditiOpt(resJenisKomoditi.data)
                    } else {
                        const resEvaluasiTeknisProduk = await kapalService.listJenisKomoditiEvaluasiTeknis(dataPpmKapal.nomorAjuKapal)
                        // console.log(resEvaluasiTeknisProduk.data.data)
                        const resJenisKomoditi = await kapalService.listJenisKomoditi(null, 0, 20)
                        const optionsJenis = resJenisKomoditi.data.data

                        const mappedSelected = resEvaluasiTeknisProduk.data.data.map(item => {
                            const found = optionsJenis.find(
                                opt => (opt.idJenisKomoditi === item.idJenisKomoditi || opt.idJenisKomoditi === item.idKomoditi)
                            );

                            if (!found) return null; // handle jika tidak ketemu

                            return {
                                idJenisKomoditi: found.idJenisKomoditi,
                                urJenisKomoditi: found.urJenisKomoditi,
                                urJenisKomoditiEn: found.urJenisKomoditiEn
                            }
                        }).filter(Boolean)
                        setValueJenisKomoditiOpt(mappedSelected)
                    }

                }
            } catch (error) {

            }
            setLoading(false)
        }
        fetchAllData()
    }, [kapalService, dataPpmKapal, userService])

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => setShowHasilInspeksi()
    const ViewHasilInspeksi = () => {
        setShowHasilInspeksi(true)
    }

    const [valueRekomOpt, setValueRekomOpt] = useState(null)
    const onChangeRekom = e => {
        setValueRekomOpt(e)
    }
    const [valueCatatan, setValueCatatan] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)
    const [valueTglRekom, setValueTglRekom] = useState(null)

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        // const response = await userService.listPegawai(search, cekBerlakuSertifikatByUpt(dataPpmKapal?.tanggalAjuKapal) === 'Y' ? localStorage.getItem('kdUnit') : '00.3', page - 1, 10)
        // return {
        //     options: response.data.data,
        //     hasMore: response.data.data.length >= 10,
        //     additional: {
        //         page: page + 1
        //     }
        // }
        try {
            const response = await pbumkuService.listPenandatangan(search, page, 10)
            let upt
            if (cekBerlakuSertifikatByUpt(dataPpmKapal.tanggalAjuKapal) === 'Y') {
                upt = localStorage.getItem('kdUnit')
            } else {
                upt = '00.3'
            }
            const dataPegawai = response?.data?.data

            if (!Array.isArray(dataPegawai)) {
                console.error('Format response API tidak sesuai:', response)
                return {
                    options: [],
                    hasMore: false,
                    additional: { page: page + 1 }
                }
            }
            const options = dataPegawai.filter(item => String(item.kdUnit) === String(upt))
            return {
                options,
                hasMore: dataPegawai.length >= 10,
                additional: {
                    page: page + 1
                }
            }
        } catch (error) {
            console.error('Gagal mengambil daftar penandatangan:', error)
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: page + 1
                }
            }
        }
    }
    const onChangePegawai = e => {
        setValuePegawaiOpt(e)
    }
    const handleChangeTglRekom = e => {
        setValueTglRekom(e.target.value)
    }
    const handleChangeCatatan = e => {
        setValueCatatan(e.target.value)
    }

    const [valueGradeRekomOpt, setValueGradeRekomOpt] = useState(null)
    async function loadOptionGrade(search, loadedOption, page) {
        const options = [
            {
                value: 'A',
                label: 'A'
            },
            {
                value: 'B',
                label: 'B',
            },
            {
                value: 'C',
                label: 'C'
            },
            {
                value: 'Non Grade',
                label: 'Non Grade'
            }
        ]
        return {
            options: options
        }
    }
    const handleChangeGrade = e => {
        setValueGradeRekomOpt(e)
    }

    async function loadOptionRekom(search, loadedOption, { page = 1 }) {
        const response = await kapalService.listKesimpulan(7)
        return {
            options: response.data,
        }
    }

    const [valueJenisKomoditiOpt, setValueJenisKomoditiOpt] = useState(null)
    async function loadOptionJenisKomoditi(search, loadedOption, { page = 1 }) {
        const response = await kapalService.listJenisKomoditi(search, page, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            addition: {
                page: page + 1
            }
        }
    }
    const onChangeJenisKomoditi = e => {
        setValueJenisKomoditiOpt(e)
    }

    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const handleClickConfirmSimpan = () => {
        setShowConfirmSimpan(true)
    }

    const [loadingSimpan, setLoadingSimpan] = useState(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowSimpanSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowSimpanFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickSimpan = async () => {
        setLoadingSimpan(true)
        try {
            let jsonRekom = {
                idInspeksi: idInspeksi,
                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                nipRekom: valuePegawaiOpt.nipPenandatangan,
                nmRekom: valuePegawaiOpt.namaPenandatangan,
                tglRekom: valueTglRekom,
                catatanRekom: valueCatatan,
                idKesimpulan: valueRekomOpt.idKesimpulan,
                gradeRekom: valueGradeRekomOpt.value,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date(),
            }

            const resRekom = await kapalService.saveRekomTeknis(jsonRekom)
            if (resRekom.data.kode === '200') {
                if (valueRekomOpt.idKesimpulan === 9) {
                    let jsonDisposisi = {
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        idDisposisi: valueRekomOpt.idDisposisiNext,
                        createdBy: localStorage.getItem('userId'),
                        createdDate: new Date()
                    }
                    await kapalService.savePenugasan(jsonDisposisi)

                    let dataStatus = {
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        kodeStatus: '026',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('userId')
                    }
                    await kapalService.saveKapalStatus(JSON.stringify(dataStatus))
                }

                valueJenisKomoditiOpt.map(async (komoditi) => {
                    let jsonRekomProduk = {
                        idInspeksiRekom: resRekom.data.id,
                        idInspeksi: idInspeksi,
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        idKomoditi: komoditi.idJenisKomoditi,
                        createdBy: localStorage.getItem('userId'),
                        createdDate: new Date()
                    }
                    await kapalService.saveRekomTeknisProduk(jsonRekomProduk)
                })

                let dataStatusNext = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    kodeStatus: valueRekomOpt.kdStatusNext,
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId')
                }
                await kapalService.saveKapalStatus(JSON.stringify(dataStatusNext))

                let jsonKapal = {
                    ...dataPpmKapal,
                    kodeStatus: valueRekomOpt.kdStatusNext,
                    updatedBy: localStorage.getItem('userId'),
                    updatedDate: new Date()
                }
                await kapalService.saveKapalHeader(jsonKapal)
                setShowConfirmSimpan(false)
                setShowSimpanSuccess(true)
            } else {
                setShowConfirmSimpan(false)
                setShowSimpanFailed(true)
            }

        } catch (error) {
            setShowConfirmSimpan(false)
            setShowSimpanFailed(true)
        }
        setLoadingSimpan(false)
    }


    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        handleCloseRekom()
    }

    const isFilled = value => {
        return value !== null &&
            value !== undefined &&
            String(value).trim() !== ''
    }

    const isEvaluasiLengkap = useMemo(() => {
        if (!Array.isArray(listEvaluasi) || listEvaluasi.length < 3) {
            return false
        } else {
            return listEvaluasi.every(item => (
                isFilled(item.idInspeksiEvaluasi) &&
                isFilled(item.nmEvaluator) &&
                isFilled(item.catatanEvaluator) &&
                isFilled(item.gradeUsul) &&
                isFilled(item.tglEvaluasi)
            ))
        }
    }, [listEvaluasi])

    return (
        <>
            <Modal
                show={showRekom}
                onHide={handleCloseRekom}
                size='xl'
                centered
                backdrop='static'
                scrollable
            >
                <Modal.Header closeButton><h6>Rekomendasi</h6></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Hasil Inspeksi</Form.Label>
                                    <Col sm="8">
                                        <Button size='sm' variant='outline-info' onClick={() => ViewHasilInspeksi()}><FaSearch />{' '}Lihat Hasil Inspeksi</Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <SummaryChecklist nomorAjuKapal={dataPpmKapal.nomorAjuKapal} isUnde5Gt={isUnder5GT} />
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Evaluasi Tim Teknis</b></Form.Label>
                                    <Col sm="2">
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="table-responsive border-bottom my-2">
                                {(loading && <Spinner />)}
                                {
                                    listEvaluasi &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsEvaluasi}
                                        data={listEvaluasi}
                                        highlightOnHover
                                        pagination
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Rekomendasi</b></Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionRekom}
                                            value={valueRekomOpt}
                                            getOptionValue={(option) => option.idKesimpulan}
                                            getOptionLabel={(option) => option.urKesimpulan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeRekom}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Komoditi</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionJenisKomoditi}
                                            value={valueJenisKomoditiOpt}
                                            getOptionValue={(option) => option.idJenisKomoditi}
                                            getOptionLabel={(option) => option.urJenisKomoditi + ' - ' + option.urJenisKomoditiEn}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeJenisKomoditi}
                                            isDisabled={!isEdit}
                                            isMulti
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Rekomendasi Grade</Form.Label>
                                    <Col sm="4">
                                        <AsyncPaginate
                                            loadOptions={loadOptionGrade}
                                            value={valueGradeRekomOpt}
                                            getOptionValue={(option) => option.value}
                                            getOptionLabel={(option) => option.label}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={handleChangeGrade}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan Rekomendasi</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" rows={5} placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={handleChangeCatatan} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Rekomendasi</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="date" placeholder="Tanggal" className="form-control-sm" value={valueTglRekom} onChange={handleChangeTglRekom} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Pegawai</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionPegawai}
                                            value={valuePegawaiOpt}
                                            getOptionValue={(option) => option.nipPenandatangan}
                                            getOptionLabel={(option) => option.nipPenandatangan + ' - ' + option.namaPenandatangan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangePegawai}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    {
                        dataPpmKapal.kodeStatus === '025' && (localStorage.getItem("role") === "6" || localStorage.getItem('isMandatoryPrimer') === 'Y') &&
                        <Button variant="primary" size="sm" onClick={() => handleClickConfirmSimpan()}
                            disabled={!isEvaluasiLengkap}
                        >
                            Proses Rekomendasi
                        </Button>
                    }
                    {' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <ModalInspeksiChecklistHasil showHasilInspeksi={showHasilInspeksi} handleCloseHasilInspeksi={handleCloseHasilInspeksi} dataPpmKapal={dataPpmKapal} />
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Simpan Rekomendasi Teknis?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSimpan ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSimpan}
                    reverseButtons
                >
                    {loadingSimpan && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSimpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showSimpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const ViewKomoditi = ({ idInspeksiEvaluasi, nomorAjuKapal }) => {
    let kapalService = useMemo(() => new KapalService(), [])

    const [valueKomoditi, setValueKomoditi] = useState(null)

    useEffect(() => {
        if (!idInspeksiEvaluasi && !nomorAjuKapal) return
        const fetchAllData = async () => {
            try {
                const resEvalTeknisProduk = await kapalService.listEvaluasiTeknisProduk(idInspeksiEvaluasi, nomorAjuKapal)
                const resJenisKomoditi = await kapalService.listJenisKomoditi(null, 0, 20)
                const optionsJenis = resJenisKomoditi.data.data
                const mappedSelected = resEvalTeknisProduk.data.data.map(item => {
                    const found = optionsJenis.find(
                        opt => (opt.idJenisKomoditi === item.idJenisKomoditi || opt.idJenisKomoditi === item.idKomoditi)
                    );

                    if (!found) return null; // handle jika tidak ketemu

                    return {
                        idJenisKomoditi: found.idJenisKomoditi,
                        urJenisKomoditi: found.urJenisKomoditi,
                        urJenisKomoditiEn: found.urJenisKomoditiEn
                    }
                }).filter(Boolean)
                setValueKomoditi(mappedSelected)

            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, nomorAjuKapal, idInspeksiEvaluasi])

    return (
        <div className='row'>
            {
                valueKomoditi && valueKomoditi.map((item, idx) => {
                    return <div className='col-12' key={idx}><b>{item.urJenisKomoditi}</b> ({item.urJenisKomoditiEn})<br /></div>
                })
            }
        </div>
    )
}


const SummaryChecklist = ({ nomorAjuKapal, isUnde5Gt }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [dataSummary, setDataSummary] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                let response
                if (isUnde5Gt === 'Y') {
                    response = await kapalService.getSummaryChecklistSA(nomorAjuKapal)
                } else {
                    response = await kapalService.getSummaryChecklist(nomorAjuKapal)
                }
                setDataSummary(response.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, nomorAjuKapal, isUnde5Gt])

    return (
        <>
            {
                isUnde5Gt === 'Y' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-3'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="6" className="control-label align-self-center mb-0" htmlFor="searchNib">Tidak Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahTidakSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
            {
                isUnde5Gt === 'T' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">OK</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahOk} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Minor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMinor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Mayor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMayor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Kritis</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahKritis} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">NA</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahNa} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
        </>
    )
}

export default ModalRekom